import { productActivationSettingFragment } from "@saleor/fragments/productactivationsetting";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { ProductActivationSetting } from "./types/ProductActivationSetting";

const activation = gql`
  ${productActivationSettingFragment}
  query ProductActivationSetting {
    productActivationSetting {
      ...ProductActivationSettingFragment
    }
  }
`;
export const useProductActivationSettingQuery = makeQuery<
  ProductActivationSetting,
  {}
>(activation);
